import React from 'react';

import {useConsumerSubscriptionPlan} from '@udemy/subscription-graphql';

import {withAboveTheFoldProvider} from 'src/components/above-the-fold/with-above-the-fold-provider.react-component';

import {usePersonalPlanSubscriptionPricingReady} from '../../hooks/usePersonalPlanSubscriptionPricingReady';
import {usePersonalPlanCampaignNotice} from '../../personal-plan-subscription-checkout-entry-context';
import {PersonalPlanHeroSkeleton} from './personal-plan-hero-skeleton.react-component';
import {PersonalPlanHero} from './personal-plan-hero.react-component';

const WithAboveTheFoldPersonalPlanHero = withAboveTheFoldProvider(PersonalPlanHero);

export const PersonalPlanHeroWrapper = () => {
    const notice = usePersonalPlanCampaignNotice();
    const plan = useConsumerSubscriptionPlan();
    const isSubscriptionPricingReady = usePersonalPlanSubscriptionPricingReady();

    if (!notice || notice.isLoading || !isSubscriptionPricingReady) {
        return <PersonalPlanHeroSkeleton />;
    }

    // Campaign copy only applies when a plan exists, matching PersonalPlanBannerWrapper.
    // Outside campaigns, notices is empty and the hero uses its own fallback copy.
    // Hero art is always the local default, not marketing notice images.
    return (
        <WithAboveTheFoldPersonalPlanHero
            plan={plan}
            notice={plan ? notice.notices?.[0] : undefined}
        />
    );
};
